"use strict";

var _slicedToArray = require("/root/workspace/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = __importDefault(require("refractor/core"));

var bash_1 = __importDefault(require("refractor/lang/bash"));

var css_1 = __importDefault(require("refractor/lang/css"));

var clike_1 = __importDefault(require("refractor/lang/clike"));

var csharp_1 = __importDefault(require("refractor/lang/csharp"));

var java_1 = __importDefault(require("refractor/lang/java"));

var javascript_1 = __importDefault(require("refractor/lang/javascript"));

var json_1 = __importDefault(require("refractor/lang/json"));

var markup_1 = __importDefault(require("refractor/lang/markup"));

var php_1 = __importDefault(require("refractor/lang/php"));

var python_1 = __importDefault(require("refractor/lang/python"));

var powershell_1 = __importDefault(require("refractor/lang/powershell"));

var ruby_1 = __importDefault(require("refractor/lang/ruby"));

var typescript_1 = __importDefault(require("refractor/lang/typescript"));

var prosemirror_commands_1 = require("prosemirror-commands");

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));

var Prism_1 = __importStar(require("../plugins/Prism"));

var Node_1 = __importDefault(require("./Node"));

var types_1 = require("../types");

[bash_1.default, css_1.default, clike_1.default, csharp_1.default, java_1.default, javascript_1.default, json_1.default, markup_1.default, php_1.default, python_1.default, powershell_1.default, ruby_1.default, typescript_1.default].forEach(core_1.default.register);

var CodeFence = /*#__PURE__*/function (_Node_1$default) {
  _inherits(CodeFence, _Node_1$default);

  var _super = _createSuper(CodeFence);

  function CodeFence() {
    var _this;

    _classCallCheck(this, CodeFence);

    _this = _super.apply(this, arguments);

    _this.handleLanguageChange = function (event) {
      var view = _this.editor.view;
      var tr = view.state.tr;
      var element = event.target;

      var _element$getBoundingC = element.getBoundingClientRect(),
          top = _element$getBoundingC.top,
          left = _element$getBoundingC.left;

      var result = view.posAtCoords({
        top: top,
        left: left
      });

      if (result) {
        var transaction = tr.setNodeMarkup(result.inside, undefined, {
          language: element.value
        });
        view.dispatch(transaction);
      }
    };

    return _this;
  }

  _createClass(CodeFence, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return prosemirror_commands_1.setBlockType(type);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Shift-Ctrl-\\": prosemirror_commands_1.setBlockType(type)
      };
    }
  }, {
    key: "handleCopyToClipboard",
    value: function handleCopyToClipboard(node) {
      var _this2 = this;

      return function () {
        copy_to_clipboard_1.default(node.textContent);

        if (_this2.options.onShowToast) {
          _this2.options.onShowToast(_this2.options.dictionary.codeCopied, types_1.ToastType.Info);
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [prosemirror_inputrules_1.textblockTypeInputRule(/^```$/, type)];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.write("```" + (node.attrs.language || "") + "\n");
      state.text(node.textContent, false);
      state.ensureNewLine();
      state.write("```");
      state.closeBlock(node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "code_block",
        getAttrs: function getAttrs(tok) {
          return {
            language: tok.info
          };
        }
      };
    }
  }, {
    key: "languageOptions",
    get: function get() {
      return Object.entries(Prism_1.LANGUAGES);
    }
  }, {
    key: "name",
    get: function get() {
      return "code_fence";
    }
  }, {
    key: "schema",
    get: function get() {
      var _this3 = this;

      return {
        attrs: {
          language: {
            default: "javascript"
          }
        },
        content: "text*",
        marks: "",
        group: "block",
        code: true,
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: "pre",
          preserveWhitespace: "full"
        }, {
          tag: ".code-block",
          preserveWhitespace: "full",
          contentElement: "code",
          getAttrs: function getAttrs(node) {
            return {
              language: node.dataset.language
            };
          }
        }],
        toDOM: function toDOM(node) {
          var button = document.createElement("button");
          button.innerText = "Copy";
          button.type = "button";
          button.addEventListener("click", _this3.handleCopyToClipboard(node));
          var select = document.createElement("select");
          select.addEventListener("change", _this3.handleLanguageChange);

          _this3.languageOptions.forEach(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                key = _ref5[0],
                label = _ref5[1];

            var option = document.createElement("option");
            var value = key === "none" ? "" : key;
            option.value = value;
            option.innerText = label;
            option.selected = node.attrs.language === value;
            select.appendChild(option);
          });

          return ["div", {
            class: "code-block",
            "data-language": node.attrs.language
          }, ["div", {
            contentEditable: false
          }, select, button], ["pre", ["code", {
            spellCheck: false
          }, 0]]];
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      return [Prism_1.default({
        name: this.name,
        deferred: !this.options.initialReadOnly
      })];
    }
  }, {
    key: "markdownToken",
    get: function get() {
      return "fence";
    }
  }]);

  return CodeFence;
}(Node_1.default);

exports.default = CodeFence;